// extracted by css-extract-rspack-plugin
export default {"GitHubAvatar_0":"ValueIcon-module__GitHubAvatar_0__N635G","Box_0":"ValueIcon-module__Box_0__W9Akp"};